export let displayedColumns: string[] = [
  'name',
  'm5',
  'm15',
  'm30',
  'h1',
  'h3',
  'h6',
  'h12',
  'h24',
];

export let displayedNames: any = {
  name: 'Max \n (mm)',
  m5: "5'",
  m15: "15'",
  m30: "30'",
  h1: '1h',
  h3: '3h',
  h6: '6h',
  h12: '12h',
  h24: '24h',
};
